import { styled } from '@mui/material/styles';

export const MeshGradientContainer = styled('div')(({ theme }) => ({
  position: "absolute",
  top: "0",
  right: "0",
  left: "0",
  bottom: "0",
  zIndex: "-1",

  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'flex-end',

  "img" : {
    objectFit: 'cover',
    
    userSelect: 'none',
    MozUserSelect: 'none', 
    WebkitUserSelect: 'none', 
    msUserSelect: 'none', 
  }
}));